import gql from 'graphql-tag';

export const SET_ADJUSTMENT_DEFAULT = gql`
  mutation SetAdjustmentDefault {
    setAdjustmentDefault
  }
`;
